import { useMsal } from "@azure/msal-react";
import { Grid, Stack, Typography } from "@mui/material";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Floaticons from "../Floaticons";
import "./PythonContent.css";
import PythonLearningCards from "./PythonLearningCards";
import PythonLearningJourney from "./PythonLearningJourney";
import mailData from ".././../data/mailData";
import { apiURL } from "../../Constant";

import "./SREContent.css";
function PythonContent() {
  const { instance } = useMsal();
  const [username, setuserName] = useState(null);
  const [isUserPresent, setuserPresent] = useState(true);
  const [value, setValue] = React.useState("1");
  const AntTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
      textTransform: "none",
      minWidth: 0,
      [theme.breakpoints.up("sm")]: {
        minWidth: 0,
      },
      fontWeight: 500,
      fontSize: "16px",
      marginRight: theme.spacing(1),
      color: "white",
      background: "#344B5D",
      borderRadius: "50px",

      "&.Mui-selected": {
        color: "#141414",
        fontWeight: 600,
        fontSize: "16px",

        backgroundColor: "#F0F0F0",
      },
      "&.Mui-focusVisible": {
        backgroundColor: "#F0F0F0",
      },
    })
  );
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  let program = "Python";
  const activeAccount = instance.getActiveAccount();
  //  const checkUserPresent = (name) => {
  //   axios
  //    .get(`${apiURL}/checkNominationList/${name}/${program}`, {
  //     headers: {
  //      "Cache-Control": "no-cache",
  //      Accept: "application/json",
  //      Pragma: "no-cache",
  //      Expires: "0",
  //     },
  //    })
  //    .then((res) => {
  //     console.log("Reponse is", res.data);
  //     let users = res.data;
  //     axios
  //      .get(`${apiURL}/checkAdminList/${name}`, {
  //       headers: {
  //        "Cache-Control": "no-cache",
  //        Accept: "application/json",
  //        Pragma: "no-cache",
  //        Expires: "0",
  //       },
  //      })
  //      .then((res) => {
  //       console.log("Reponse is", res.data);

  //       users.length != 0 || res.data.length != 0
  //        ? setuserPresent(true)
  //        : setuserPresent(false);
  //      })
  //      .catch((err) => {
  //       console.log(err);
  //      });
  //    })
  //    .catch((err) => {
  //     console.log(err);
  //    });
  //  };
  const checkUserPresent = (name) => {
    axios
      .get(`${apiURL}/checkUserActive/${name}`, {
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let activeUser = res.data;
        if (activeUser.length != 0) {
          axios
            .get(`${apiURL}/checkNominationList/${name}/${program}`, {
              headers: {
                "Cache-Control": "no-cache",
                Accept: "application/json",
                Pragma: "no-cache",
                Expires: "0",
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              let users = res.data;
              users.length != 0 ? setuserPresent(true) : setuserPresent(false);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          axios
            .get(`${apiURL}/checkAdminList/${name}`, {
              headers: {
                "Cache-Control": "no-cache",
                Accept: "application/json",
                Pragma: "no-cache",
                Expires: "0",
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              console.log("Reponse is", res.data);

              res.data.length != 0
                ? setuserPresent(true)
                : setuserPresent(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (activeAccount) {
      setuserName(activeAccount.idTokenClaims.enterpriseID);

      checkUserPresent(activeAccount.idTokenClaims.enterpriseID);
    } else {
      setuserName(null);
    }
  }, [activeAccount.idTokenClaims.enterpriseID]);
  return (
    <>
      <div id="pythonSection">
        <div className="main-banner">
          <img
            src="images/Python/banner.png"
            alt="Banner"
            className="banner-img"
          />
          <img
            src="images/Home/banner-strip.png"
            alt="strip"
            className="strip-img"
          />
          <div className="announcemnt-box">
            <p>
              <img
                src="images/Home/speaker.png"
                alt="speaker"
                className="speaker-img"
              />
              <marquee
                width="92%"
                direction="left"
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                {" "}
                <b>Come Join Us</b> on an exhilarating learning Journey on ABC
                University Platform!!!
              </marquee>
            </p>
          </div>
          <Floaticons />
        </div>
        {isUserPresent ? (
          <div className="main-container">
            {/* section 1  */}
            <div className="about-container">
              <div className="about-wrap">
                <h2>About Python</h2>
                <p>
                  Python is one of the most popular programming languages in the
                  world. It is a general-purpose language, which is used in a
                  range of applications, including data science, software, web
                  development, Automation, Machine learning, Data Science and
                  others.
                </p>
              </div>
            </div>
            {/* section 2  */}
            {/* <div className="program-container">
       <div className="program-wrap">
        <TabContext value={value}>
         <Box sx={{ borderBottom: 1, borderColor: "#B6C6F9" }}>
          <TabList
           sx={{ paddingLeft: "20px", paddingRight: "20px", paddingBottom: "10px" }}
           onChange={handleChange}
           aria-label="lab API tabs example"
          >
           <AntTab label="Program Objectives" value="1" />
           <AntTab label="Recordings & Guidelines" value="2" />
          </TabList>
         </Box>
         <TabPanel value="1" sx={{ marginTop: "40px" }}>
          {" "}
          <Stack direction={"row"}>
           <Box sx={{ width: "60%" }}>
            <ul>
             <li>
              This program is intended for resources to enable them with the required
              knowledge on Python Essentials, Python Advance, Data Analysis with Python,
              Data Visualisation with Python and Python Web Frameworks
             </li>
             <li>
              The objective of this program is building a skilled Python workforce and
              ensure reliable & resilience solution delivering for clients.{" "}
             </li>
            </ul>
           </Box>
          </Stack>
         </TabPanel>
         <TabPanel sx={{ marginTop: "40px" }} value="2">
          <Box sx={{ justifyContent: "center", display: "flex", alignItems: "center" }}>
           <Stack
            direction={"row"}
            spacing={2}
            sx={{
             height: "300px",
             display: "flex",
             width: "80%",
             justifyContent: "center",
            }}
           >
        

            <Stack
             sx={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}
             spacing={3}
            >
             <iframe
              id="kmsembed-1_rm2f1712"
              width="450"
              height="300"
              src="https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_rm2f1712/uiConfId/27188232/st/0"
              class="kmsembed"
              allowfullscreen
              webkitallowfullscreen
              mozAllowFullScreen
              allow="autoplay *; fullscreen *; encrypted-media *"
              referrerPolicy="no-referrer-when-downgrade"
              frameborder="0"
              title="Python SME connect  _ Shell University-20230614_150511-Meeting Recording (1)"
             ></iframe>

             <Stack direction={"row"} spacing={0}>
              <Typography>SME Connect</Typography>
              <img
               style={{ width: "30px", height: "28px " }}
               src="images/tosca/arrow.png"
              ></img>
             </Stack>
            </Stack>
           </Stack>
          </Box>
         </TabPanel>
        </TabContext>
        
       </div>
      </div> */}

            <div id="SRE-Objective">
              <div className="program-container">
                <div className="program-wrap">
                  <h2>Program Objectives</h2>
                  <Grid container sx={{ marginBottom: "1rem" }}>
                    <Grid item xs={8}>
                      <Stack spacing={1}>
                        <Stack
                          direction={"row"}
                          spacing={1}
                          alignItems={"baseline"}
                        >
                          <img
                            style={{ width: "16px", height: "16px" }}
                            src="images/bulletWhite.png"
                          ></img>
                          <Typography>
                            {" "}
                            This program is intended for resources to enable
                            them with the required knowledge on Python
                            Essentials, Python Advance, Data Analysis with
                            Python, Data Visualisation with Python and Python
                            Web Frameworks
                          </Typography>
                        </Stack>
                        <Stack
                          direction={"row"}
                          spacing={1}
                          alignItems={"baseline"}
                        >
                          <img
                            style={{ width: "16px", height: "16px" }}
                            src="images/bulletWhite.png"
                          ></img>
                          <Typography>
                            The objective of this program is building a skilled
                            Python workforce and ensure reliable & resilience
                            solution delivering for clients.{" "}
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                  {/* <ul id="double">
          <li>
           This program is intended for resources to enable them with the required
           knowledge on Python Essentials, Python Advance, Data Analysis with Python, Data
           Visualisation with Python and Python Web Frameworks
          </li>
          <li>
           The objective of this program is building a skilled Python workforce and ensure
           reliable & resilience solution delivering for clients.{" "}
          </li>
         </ul> */}
                </div>
              </div>
            </div>
            <PythonLearningJourney />
            <div className="external-certification-container">
              <h5>External Certifications</h5>
              <p>
                Complete your learning journey and earn accredited external
                certification in the area of your expertise which can help in
                advancing your career.
              </p>
              <div className="ex-wrapper">
                <div className="ex-box">
                  <img
                    src="images/Python/certifications/Entry-Level-New.png"
                    alt="certification-icon"
                  />
                  <span>Certified Entry-Level Python Programmer</span>
                </div>
                <div className="ex-box">
                  <img
                    src="images/Python/certifications/Associate-Level-New.png"
                    alt="certification-icon"
                  />
                  <span>Certified Associate in Python Programming</span>
                </div>
              </div>
            </div>
            <PythonLearningCards />
            {/* section 3  */}
            {/* <div className="SRE-card-container">
                    <div className="SRE-card-wrap">
                        <div className="SRE-card-row">
                            <img src="images/SRE/tile-1.png" alt="tile-1" className='SRE-card-tile' />
                            <h4 className='tile-heading'>Lorem ipsum</h4>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci distinctio facere.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci distinctio facere.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci distinctio facere.</p>
                        </div>
                    </div>
                    <div className="SRE-card-wrap">
                        <div className="SRE-card-row">
                            <img src="images/SRE/tile-2.png" alt="tile-2" className='SRE-card-tile' />
                            <h4 className='tile-heading'>Lorem ipsum</h4>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci distinctio facere.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci distinctio facere.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci distinctio facere.</p>
                        </div>
                    </div>
                    <div className="SRE-card-wrap">
                        <div className="SRE-card-row">
                            <img src="images/SRE/tile-3.png" alt="tile-3" className='SRE-card-tile' />
                            <h4 className='tile-heading'>Lorem ipsum</h4>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci distinctio facere.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci distinctio facere.</p>
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci distinctio facere.</p>
                        </div>
                    </div>
                </div> */}

            {/* section 4  */}
            <div className="features-container">
              <h5>Program Highlights</h5>
              <div className="features-wrap">
                <div className="features-row">
                  <img
                    src="images/Python/feature-icon1.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Easy to code </p>
                </div>
                <div className="features-row">
                  <img
                    src="images/Python/feature-icon2.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Easy to Read </p>
                </div>
                <div className="features-row">
                  <img
                    src="images/Python/feature-icon3.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Object-Oriented Language </p>
                </div>
                <div className="features-row">
                  <img
                    src="images/Python/feature-icon4.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>High-Level Language </p>
                </div>
                <div className="features-row">
                  <img
                    src="images/Python/feature-icon5.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Large Standard Library </p>
                </div>
                <div className="features-row">
                  <img
                    src="images/Python/feature-icon6.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Integrated language </p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="alter-conatiner">
            <p>
              You are not enrolled to this learning program. Please contact
              &nbsp;
              <a
                onClick={() => {
                  window.open(`mailto:${mailData.LKM_ABCUniversity_mail}`);
                }}
                href=""
              >
                {mailData.LKM_ABCUniversity_mail}
              </a>
              &nbsp; for any queries regarding the program.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default PythonContent;
